import { render, staticRenderFns } from "./DeptRoleUserModal.vue?vue&type=template&id=a8e79882&scoped=true"
import script from "./DeptRoleUserModal.vue?vue&type=script&lang=js"
export * from "./DeptRoleUserModal.vue?vue&type=script&lang=js"
import style0 from "./DeptRoleUserModal.vue?vue&type=style&index=0&id=a8e79882&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8e79882",
  null
  
)

export default component.exports